import type { ReactNode } from 'react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { STATUS_COLOR_CLASS, type StatusColorTone } from '@/styles/statusColors';

interface StatusBadgeProps {
  tone: StatusColorTone;
  children: ReactNode;
  className?: string | undefined;
}

export function StatusBadge({ tone, children, className }: StatusBadgeProps) {
  return <Badge className={cn(STATUS_COLOR_CLASS[tone], className)}>{children}</Badge>;
}
